import React, { useEffect } from "react";
import TechnicalSupport from "../shared/components/TechnicalSupport";
import useStore from '../shared/store';
import HumburgerButton from "../shared/HumburgerButton";

const EMAIL_TYPES = {
	TECH_SUPPORT: 'tech_support',
	CONTACT_CLINIC: 'contact_clinic',
};

// ─── Font injection ────────────────────────────────────────────────────────────
const injectFont = () => {
	if (document.getElementById('help-font')) return;
	const link = document.createElement('link');
	link.id = 'help-font';
	link.rel = 'stylesheet';
	link.href = 'https://fonts.googleapis.com/css2?family=Manrope:wght@600;700;800&family=Inter:wght@400;500;600&display=swap';
	document.head.appendChild(link);
};

// ─── Inline styles ─────────────────────────────────────────────────────────────
const injectStyles = () => {
	if (document.getElementById('help-styles')) return;
	const style = document.createElement('style');
	style.id = 'help-styles';
	style.textContent = `
		.hp-wrap, .hp-wrap *, .hp-wrap *::before, .hp-wrap *::after {
			box-sizing: border-box;
		}
		.hp-wrap {
			font-family: 'Inter', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Arial, sans-serif;
			padding: 32px 40px;
			background: #F5F3F0;
			min-height: 100vh;
		}

		/* ── Page title ── */
		.hp-title {
			display: flex;
			align-items: center;
			gap: 14px;
			margin-bottom: 24px;
		}
		.hp-title__text {
			font-family: 'Manrope', sans-serif;
			font-size: 28px;
			font-weight: 800;
			color: #18181A;
			letter-spacing: -0.02em;
			white-space: nowrap;
		}
		.hp-title__line {
			flex: 1;
			height: 2px;
			background: linear-gradient(90deg, rgba(228,112,41,0.45) 0%, transparent 100%);
			border-radius: 2px;
		}

		/* ── Section wrapper for each TechnicalSupport card ── */
		.hp-section {
			margin-bottom: 16px;
		}
		.hp-section:last-child {
			margin-bottom: 0;
		}

		@media (max-width: 768px) {
			.hp-wrap { padding: 24px 20px; }
		}
	`;
	document.head.appendChild(style);
};


// ─── Main component ────────────────────────────────────────────────────────────
const Help = ({ smallScreenView, handleMenuClick }) => {
	const { user } = useStore();
	const isPatient = !user.roles;

	useEffect(() => {
		injectFont();
		injectStyles();
	}, []);

	return (
		<>
			<HumburgerButton smallScreenView={smallScreenView} handleMenuClick={handleMenuClick} />

			<div className="hp-wrap">

				{/* ── Page title ── */}
				<div className="hp-title">
					<span className="hp-title__text">Help</span>
					<div className="hp-title__line" />
				</div>

				{/* ── Technical support cards ── */}
				<div className="hp-section">
					<TechnicalSupport emailType={EMAIL_TYPES.TECH_SUPPORT} />
				</div>

				{isPatient && (
					<div className="hp-section">
						<TechnicalSupport emailType={EMAIL_TYPES.CONTACT_CLINIC} />
					</div>
				)}

			</div>
		</>
	);
};

export default Help;